import React from "react";
import { TrendingUp, FileCheck, PhoneIncoming, Quote } from "lucide-react";

export const Results = () => {
  const results = [
    {
      icon: FileCheck,
      value: "+3 à +10",
      label: "devis qualifiés / mois",
      description: "Des demandes sérieuses, pas des curieux",
    },
    {
      icon: TrendingUp,
      value: "+30%",
      label: "de transformation",
      description: "Devis → Client grâce aux relances auto",
    },
    {
      icon: PhoneIncoming,
      value: "0",
      label: "appel manqué",
      description: "Chaque demande est captée et traitée",
    },
  ];

  const testimonials = [
    {
      quote: "En 30 jours, j'ai récupéré 4 chantiers que j'aurais perdus avant. Le système se paie tout seul.",
      name: "Jean-Marc Favre",
      job: "Plombier à Lausanne",
      image: "https://images.unsplash.com/photo-1676210134190-3f2c0d5cf58d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxwbHVtYmVyJTIwcGlwZSUyMGZpeGluZyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzYyNTU3NDB8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      quote: "Je ne rate plus aucun appel même quand je suis sur une installation. L'IA gère tout, c'est impressionnant.",
      name: "Patrick Müller",
      job: "Électricien à Genève",
      image: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2lhbiUyMGNvbnN0cnVjdGlvbiUyMHdvcmtlciUyMHNpdGV8ZW58MHx8fHwxNzc2MjU1NzQwfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      quote: "Mes devis sont maintenant relancés automatiquement. J'ai signé 3 contrats de plus ce mois-ci grâce à ça.",
      name: "Alain Rochat",
      job: "Serrurier à Fribourg",
      image: "https://images.pexels.com/photos/13821194/pexels-photo-13821194.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
  ];

  return (
    <section id="results" className="py-14 lg:py-28 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="section-label text-accent mb-4">Résultats</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-6 tracking-tight">
            Des résultats{" "}
            <span className="text-accent">mesurables</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Pas de promesses vides. Voici ce que nos clients obtiennent concrètement.
          </p>
        </div>

        {/* Results Cards */}
        <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto mb-20">
          {results.map((result, index) => {
            const Icon = result.icon;
            return (
              <div
                key={result.label}
                className="bg-white border-2 border-slate-200 rounded-md p-8 text-center hover:border-accent/50 transition-all"
                style={{boxShadow: '4px 4px 0px rgba(30, 90, 158, 0.1)'}}
                data-testid={`result-card-${index}`}
              >
                <div className="w-14 h-14 rounded-md bg-accent/10 flex items-center justify-center mx-auto mb-5">
                  <Icon className="w-7 h-7 text-accent" />
                </div>
                <p className="stat-number text-accent mb-2">
                  {result.value}
                </p>
                <p className="text-lg font-bold text-slate-900 mb-2">
                  {result.label}
                </p>
                <p className="text-slate-500 text-sm">
                  {result.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.name} 
              className="bg-white border-2 border-slate-200 rounded-md overflow-hidden hover:border-primary/40 transition-all"
              style={{boxShadow: '4px 4px 0px rgba(30, 90, 158, 0.1)'}}
            >
              {/* Image */}
              <div className="h-48 overflow-hidden">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              {/* Content */}
              <div className="p-6">
                <Quote className="w-8 h-8 text-primary/20 mb-3" />
                <p className="text-slate-700 italic mb-4 leading-relaxed text-sm">
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-slate-200 pt-4">
                  <p className="font-bold text-slate-900">{testimonial.name}</p>
                  <p className="text-sm text-accent font-medium">{testimonial.job}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Results;
